export const showcaseTableSelector = state => state.showcaseTable;
